// Ant Design
import { Layout, theme } from 'antd';

// project import
import { collapsedWidth } from '../Drawer/MiniDrawerStyled';
import { useTheme } from '@/App';

const { Header } = Layout;

// ==============================|| HEADER - APP BAR STYLED ||============================== //

const AppBarStyled = ({ open, children, ...other }) => {
  const { isDark } = useTheme();
  const { token } = theme.useToken();
  // Header stays pinned at the collapsed rail width — the sidebar overlays on
  // top when opened instead of pushing/resizing the header.
  const marginLeft = collapsedWidth;
  const width = `calc(100% - ${marginLeft}px)`;

  return (
    <Header
      {...other}
      // Stays below AntD's own popup layers (Modal/Drawer/Popover default to
      // z-index 1000) so every modal in the app renders above the persistent
      // header instead of being covered by it. Only needs to stay under the
      // sidebar overlay (z-1300), never above floating AntD components.
      className="fixed z-[100] transition-all duration-300 ease-in-out"
      style={{
        marginLeft: `${marginLeft}px`,
        width,
        padding: 0,
        height: 64,
        lineHeight: '64px',
        background: isDark ? token.colorBgContainer : '#fff',
      }}
    >
      {children}
    </Header>
  );
};

export default AppBarStyled;
